import { useState } from "react";
import Select from "react-select"; 
//-----------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, MyFormData, numberReducer, objectReducer
} from "src/components/common/functions";
//-----------------------------------------------------------------------------------------
export default function AddForm({
    setUserList, 
    closeIt, 
    data
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [curData, setData] = useState((data && JSON.parse(data)) || [{
        code: "", 
        unit: "", 
        unitPrice: "", 
        quantity: "", 
        lineTotal: ""
    }]);
    const basicData = {
        "Service": {
            "PM-100": {
                "description": "Project Management",
                "unit": {"DAY": 185 * 8, "HR": 185}
            },
            "PM-101": {
                "description": "Project Coordination",
                "unit": {"DAY": 145 * 8, "HR": 145}
            },
            "P-124": {
                "description": "Utility Field Foreman",
                "unit": {"DAY": 145 * 10, "HR": 145}
            },
            "LP-100": {
                "description": "Licensed Professional (Civil / Surveyor)",
                "unit": {"DAY": 190 * 8, "HR": 190}
            },
            "LU-100": {
                "description": "LiDAR / UAV", // / Data Processing and Extraction
                "unit": {"DAY": 101 * 8, "HR": 101}
            },
            "CAD-100": {
                "description": "CAD Technician", 
                "unit": {"HR": 117, "DAY": 117 * 8}
            },
            "D-100": {
                "description": "Data Processing and Extraction", 
                "unit": {"HR": 132.5, "DAY": 132.5 * 8} // SHEET
            },
            "C-100": {
                "description": "CLERICAL", 
                "unit": {"SHEET": 101}
            },
            "S-100": {
                "description": "SKETCHES", 
                "unit": {"SHEET": 101}
            },
        },
        "Utility Location & Gas Transmission Standby": {
            "L-100": {
                "description": "1 Person Utility Designation W/GPR & EM Pipe Locator",
                "unit": {"DAY": 185.5 * 10, "HR": 185.5}
            },
            "L-101": {
                "description": "2 Person Utility Designation W/GPR & EM Pipe Locator",
                "unit": {"DAY": 371 * 10, "HR": 371}
            },
            "L-102": {
                "description": "2 Person Utility Multiple Antennae - GPR",
                "unit": {"DAY": 371 * 10, "HR": 371}
            },
            "L-103": {
                "description": "Utility Multiple Antennae - GPR Night Job/OT/Emergency",
                "unit": {"DAY": 371 * 1.6 * 10, "HR": 371 * 1.6}
            },
        }
    };
    const options = Object.entries(basicData).map(
        ([key, item]) => 
        ({
            label: key,
            options: Object.entries(item).map(
                ([code, item]) => 
                ({
                    label: `${code} ${item.description}`,
                    value: code
                })
            )
        })
    );
    const flatOptions = Object.values(basicData).reduce(objectReducer);
    return(
    <Modal
        width = {1280}
        maxWidth = "100%"
        closeIt = {closeIt}
        title = "Forms"
        actionKey = "Add"
        handleFormSubmit = {async e => {
            e.preventDefault();
            const formData = new MyFormData(e.currentTarget);
            formData.append("action", "Create");
            //----------------------------------------
            setShowLoader(true);
            const res = await myAxios("forms/checklist.php", formData);
            setShowLoader(false);
            if(!res) return;
            //----------------------------------------
            setUserList(forms => [...forms, res.data]);
            closeIt();
        }}
    >
        <div className = "m-3">
            <table className = "table">
                <thead>
                    <tr>
                        <th>Service</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Suggest Price</th>
                        <th>Actual Price</th>
                        <th>Line Total</th>
                        <th style = {{border: "none"}}></th>
                        <th style = {{border: "none"}}></th>
                    </tr>
                </thead>
                <tbody>
                {curData.map((d, i) => 
                <tr key = {i}>
                    <td>
                        <article style = {{ minWidth: 400}}>
                        <Select 
                            options = {options}
                            onChange = {e => {
                                setData([...curData.slice(0, i),
                                    { 
                                        code: e.value, 
                                        unit: "", 
                                        unitPrice: "", 
                                        quantity: "", 
                                        lineTotal: ""
                                    },
                                    ...curData.slice(i + 1)
                                ]);
                            }}
                        />
                        </article>
                    </td>
                    <td>
                        <input
                            required
                            type = "number"
                            step = "any"
                            min = "0"
                            className = "form-control"
                            style = {{maxWidth: "100px"}}
                            value = {d.quantity ?? ""}
                            onChange = {e => {
                                const newData = curData.map(
                                    (dd, ii) => ii === i? 
                                    {
                                        ...dd, 
                                        quantity: 
                                        e.currentTarget.value, 
                                        lineTotal: 
                                        dd.unitPrice !== "" && 
                                        e.currentTarget.value !== ""?
                                        (
                                            dd.unitPrice * e.currentTarget.value
                                        ).toFixed(2):""
                                    }
                                    :dd
                                );
                                setData(newData);
                            }}
                        />
                    </td>
                    <td>
                        <select
                            required
                            className = "form-control"
                            style = {{maxWidth: "100px"}}
                            value = {d.unit ?? ""}
                            onChange = {e => {
                                const value = e.currentTarget.value;
                            const newData = curData.map((dd, ii) => ii === i? ({
                                ...dd, 
                                unit: value, 
                                unitPrice: flatOptions[d.code]?.unit?.[value],
                                lineTotal: dd.quantity !== "" && value !== ""?
                                (dd.quantity * flatOptions[d.code]?.unit?.[value]).toFixed(2):""
                            }):dd);
                            setData(newData);
                        }}>
                            <option value = {""}>Select</option>
                            {
                            Object.entries(flatOptions[d.code]?.unit ?? {}).map(([key, value], index) => <option key = {index}>{key}</option>)
                            }
                        </select>
                    </td>
                    <td>
                        {d.unit?
                        <input
                            disabled
                            className = "form-control inline"
                            style = {{maxWidth: "100px"}}
                            value = {flatOptions[d.code]?.unit?.[d.unit] ?? ""}
                        />
                        :<></>}
                    </td>
                    <td>
                        {d.unit?
                        <input
                            required
                            type = "number"
                            step = "0.01"
                            min = "0"
                            className = "form-control inline"
                            style = {{maxWidth: "100px"}}
                            value = {d.unitPrice ?? ""}
                            onChange = {e => {
                                const newData = curData.map((dd, ii) => ii === i? ({
                                    ...dd, 
                                    unitPrice: e.currentTarget.value, 
                                    lineTotal: dd.quantity !== "" && e.currentTarget.value !== ""?
                                    (dd.quantity * e.currentTarget.value).toFixed(2):""
                                }):dd);
                                setData(newData);
                            }}
                        />:<></>}
                    </td>
                    <td>
                        <input type = "number" step = "any" readOnly className = "form-control" style = {{width: "100%"}} value = {d.lineTotal}/>
                    </td>
                    <td style = {{borderTop:"none"}}><span className = "btn btn-primary" onClick = {() => {
                        setData(
                            [
                                ...curData.slice(0, i + 1), 
                                {
                                    code: "", 
                                    unit: "", 
                                    unitPrice: "", 
                                    quantity: "", 
                                    lineTotal: ""
                                },...curData.slice(i + 1)
                            ]);
                    }}>Add</span></td>
                    {curData.length === 1?null:<td style = {{borderTop:"none"}}><span className = "btn btn-danger" onClick = {() => {
                        const newData = curData.filter((item, itemIndex) => itemIndex !== i);
                        setData(newData);
                    }}>Delete</span></td>}
                </tr>
                )
                }
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Subtotal:</td>
                    <td><input name = "subtotal" className = "form-control" type = "number" step = "any" readOnly style = {{width: "100%"}} value = {
                        (curData.map(d => d.unitPrice !== "" || d.quantity !== ""?
                        (d.unitPrice * d.quantity):0).map(value => parseFloat(value.toFixed(2))).reduce(numberReducer, 0)).toFixed(2) || ""}/></td>
                    <td style = {{borderTop:"none"}}></td>
                    <td style = {{borderTop:"none"}}></td>
                </tr>
                </tbody>
            </table>
        </div>
    </Modal>
    )
}